import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
  export class DataService {
    private record: any;
  
    setRecord(data: any) {
      this.record = data;
    }
  
    getRecord() {
      return this.record;
    }

    clearRecord(){
      this.record=''
    }
  }
  
  